/**
 * The maneuver baseline's display label, in one place.
 *
 * The shared color legend, the settings row and the picker all name the selected baseline; deriving
 * it here keeps them from drifting into three spellings of the same thing.
 */

import { maneuverBaselineStore } from '../store/maneuverBaselineStore';

/** "<name> — <config>", or just "Baseline" when nothing is selected. */
export function maneuverBaselineLabel(): string {
  const name = maneuverBaselineStore.baselineName();
  if (!name) { return 'Baseline'; }
  const config = maneuverBaselineStore.baselineConfig();
  return config ? `${name} — ${config}` : name;
}
